import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CapitalCall from 'components/global/CapitalCall/CapitalCall';
import { canPerformAction } from '../../../../libs/programAccessPermissions';
import $capitalCall from '../../../../components/global/CapitalCall/CapitalCall.signals';
import loaderSignal from '../../../../signals/Loader.signal';
import BreadCrumbWrapper from '../../../global/BreadCrumbs/BreadCrumbs';

const EdoCapitalCall = () => {
  const location = useLocation();
  const { capitalCall } = $capitalCall.value;
  const [canView, setCanView] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  // Get funding program ID from capital call data
  const fundingProgramId = capitalCall?.fund?.fundingProgramMembership?.fundingProgram?.id;

  // Check permissions when capital call data is available
  useEffect(() => {
    const checkPermissions = async () => {
      if (!fundingProgramId) {
        // No program ID yet, wait for data to load
        if (capitalCall) {
          // Data loaded but no program ID - allow view (edge case)
          setCanView(true);
          setIsChecking(false);
        } else {
          // Still loading
          setIsChecking(true);
        }
        return;
      }

      try {
        loaderSignal.update({ isContentLoading: true });
        const viewPerm = await canPerformAction(fundingProgramId, 'canView');
        setCanView(viewPerm);
        setIsChecking(false);
      } catch (error) {
        console.error('Error checking permissions:', error);
        setCanView(false);
        setIsChecking(false);
      } finally {
        loaderSignal.reset();
      }
    };

    checkPermissions();
  }, [fundingProgramId, capitalCall]);

  if (isChecking && !capitalCall) {
    return (
      <BreadCrumbWrapper labels={['']}>
        <div className="bg-white p-32 border border-gray shadow-sm">
          <p className="text-center">Loading...</p>
        </div>
      </BreadCrumbWrapper>
    );
  }

  if (!isChecking && !canView) {
    return (
      <BreadCrumbWrapper labels={['']}>
        <div className="bg-white p-32 border border-gray shadow-sm">
          <h3 className="text-center">Access Denied</h3>
          <p className="text-center">
            You do not have permission to view this capital call.
          </p>
        </div>
      </BreadCrumbWrapper>
    );
  }

  return <CapitalCall />;
};

export default EdoCapitalCall;
